//app版本
export default [
    {
        path: 'appVersion',
        name: 'appVersion',
        meta: {
            title: 'app版本',
            icon: 'appVersion'
        },
        hidden: false,
        component: () => import("@/views/system/appVersion/index.vue"),
        children: [{
            path: 'versionManagement',
            name: 'versionManagement',
            meta: {
                title: '版本管理',
                icon: 'versionManagement'
            },
            hidden: false,
            component: () => import("@/views/system/appVersion/versionManagement.vue"),
        }, {
            path: 'versionReview',
            name: 'versionReview',
            meta: {
                title: '版本审核',
                icon: 'versionReview'
            },
            hidden: false,
            component: () => import("@/views/system/appVersion/versionReview.vue"),
        }]
    }

]